export type AppLanguage = 'de' | 'en' | 'ar' | 'ru' | 'fr' | 'tr';
export type TextDirection = 'ltr' | 'rtl';

export interface LanguageMetadata {
  code: AppLanguage;
  labelKey: string;
  locale: string;
  direction: TextDirection;
  flag: string;
}

export const DEFAULT_LANGUAGE: AppLanguage = 'de';

export const SUPPORTED_LANGUAGES: readonly LanguageMetadata[] = [
  { code: 'de', labelKey: 'language.de', locale: 'de-DE', direction: 'ltr', flag: 'flags/de.svg' },
  { code: 'en', labelKey: 'language.en', locale: 'en-US', direction: 'ltr', flag: 'flags/gb.svg' },
  { code: 'ar', labelKey: 'language.ar', locale: 'ar', direction: 'rtl', flag: 'flags/ar.svg' },
  { code: 'ru', labelKey: 'language.ru', locale: 'ru-RU', direction: 'ltr', flag: 'flags/ru.svg' },
  { code: 'fr', labelKey: 'language.fr', locale: 'fr-FR', direction: 'ltr', flag: 'flags/fr.svg' },
  { code: 'tr', labelKey: 'language.tr', locale: 'tr-TR', direction: 'ltr', flag: 'flags/tr.svg' },
] as const;

export const LANGUAGE_BY_CODE: Readonly<Record<AppLanguage, LanguageMetadata>> =
  Object.fromEntries(SUPPORTED_LANGUAGES.map((language) => [language.code, language])) as Record<AppLanguage, LanguageMetadata>;

export function isAppLanguage(value: unknown): value is AppLanguage {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(LANGUAGE_BY_CODE, value);
}
